export const DocumentAccessRole = {
  Viewer: 'viewer',
  Commenter: 'commenter',
  Editor: 'editor',
};

export const DocumentAccessRolesLabel = {
  [DocumentAccessRole.Viewer]: 'Viewer',
  [DocumentAccessRole.Commenter]: 'Commenter',
  [DocumentAccessRole.Editor]: 'Editor',
};

export const DocumentAccessRolesDescription = {
  [DocumentAccessRole.Viewer]: 'Can view the document',
  [DocumentAccessRole.Commenter]: 'Can view and comment on the document',
  [DocumentAccessRole.Editor]: 'Can edit the document',
};

export const ALL_DOCUMENT_ACCESS_ROLES = [
  DocumentAccessRole.Viewer,
  DocumentAccessRole.Commenter,
  DocumentAccessRole.Editor,
];
